import ExitTrigger from '@mvps-genesis/exit-trigger';
import Checkout from 'extensions/checkout/Checkout.js';
import 'extensions/checkout/checkout.scss';
import {PageManager} from 'genesis-packages/core';
import './OSEL.scss';

export default class OPAY extends PageManager {

	constructor (pageContext) {

		super(pageContext);

	}

	onReady () {
		new Checkout();

		new ExitTrigger('.js-exit-trigger', {
			message: 'Are you sure you want to exit checkout?',
			redirectUrl: this.pageContext.Basket_Url
		});

		const oselForm = document.getElementById('osel-form');
		if (oselForm) {
			this.resetButtons(oselForm);
			oselForm.addEventListener('submit', () => this.handleSubmit(oselForm));
		}

	}

	handleSubmit (form) {
		const buttons = form.querySelectorAll('[type="submit"]');
		const loadingText = 'Loading...';

		this.sendGTMShippingOption(form);

		if (buttons) {
			for (const button of buttons) {
				button.disabled = true;

				if (button.nodeName === 'INPUT') {
					button.setAttribute('data-original-text', button.value);
					button.value = loadingText;
				} else {
					button.setAttribute('data-original-text', button.innerText);
					button.innerText = loadingText;
				}
			}
		}
	}

	resetButtons (form) {
		const buttons = form.querySelectorAll('[type="submit"]');
		if (buttons) {
			for (const button of buttons) {
				const originalText = button.getAttribute('data-original-text');
				button.disabled = false;

				if (!originalText) {
					continue;
				}

				if (button.nodeName === 'INPUT') {
					button.value = originalText;
				} else {
					button.innerText = originalText;
				}
			}
		}
	}

	sendGTMShippingOption (form) {
		const selectedShipping = form.querySelector('[name="ShippingMethod"]:checked');

		if (!selectedShipping) {
			return;
		}

		const checkoutOption = selectedShipping.getAttribute('data-gtm-name');
		const checkoutOptionValue = selectedShipping.getAttribute('data-gtm-value');

		window.dataLayer = window.dataLayer || [];

		window.dataLayer.push({
			event: 'shipping_selected',
			/* eslint-disable camelcase */
			ga_event_action: 'Checkout Option',
			ga_event_category: 'Ecommerce',
			ga_event_label: 'Shipping ' + checkoutOption,
			ga_event_noninteraction_hit: false,
			ga_event_value: '',
			shipping_option: checkoutOption,
			shipping_price: parseFloat(checkoutOptionValue || 0)
			/* eslint-enable camelcase */
		});
	}

};
